module.exports = __webpack_public_path__ + "static/media/github-green.7af1de3d.svg";